module.exports = __webpack_public_path__ + "assets/images/bola-de-sinuca_b2fc4b504f353881056d887c32e83245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/esfera/bola-de-sinuca.png
// module id = 203
// module chunks = 0